import { LoadingSpinner } from '@/components/LoadingSpinner.tsx'
import { ReleaseTable } from '@/components/analytics/ReleaseTable.tsx'
import { STORY_STATUSES } from '@/constants/STORY_STATUSES.ts'
import { useUserContext } from '@/contexts/UserContext.tsx'
import { useQueryAnalyticsReleaseFlags } from '@/requests/queries/useQueryAnalytics.tsx'
import { useEffect, useMemo, useState } from 'react'

export const ReleasesReport = () => {
  const { apiKey } = useUserContext()
  const [showAll, setShowAll] = useState(true)

  const { loading: loadingAccepted, data: acceptedReleases } = useQueryAnalyticsReleaseFlags(
    apiKey,
    STORY_STATUSES.ACCEPTED,
  )
  const { loading: loadingUnstarted, data: unstartedReleases } = useQueryAnalyticsReleaseFlags(
    apiKey,
    STORY_STATUSES.UNSTARTED,
  )

  const releases = useMemo(
    () => [...(acceptedReleases?.releases ?? []), ...(unstartedReleases?.releases ?? [])],
    [acceptedReleases, unstartedReleases],
  )

  useEffect(() => {
    if (releases.length > 10) {
      setShowAll(false)
    }
  }, [releases])

  if (loadingAccepted || loadingUnstarted) {
    return (
      <div className="flex justify-center items-center w-[calc(100vw-178px)] h-full">
        <LoadingSpinner />
      </div>
    )
  }

  if (!acceptedReleases || !unstartedReleases) {
    return <></>
  }

  const releasesToShow = [
    ...(showAll ? acceptedReleases.releases : acceptedReleases.releases.slice(-3)),
    ...unstartedReleases.releases,
  ]

  return (
    <>
      <ReleaseTable releases={releasesToShow} showAll={showAll} setShowAll={setShowAll} />
    </>
  )
}
